export function CodeStyles() {
	return (
		<style global jsx>
{`code[class*='language-'], pre[class*='language-'] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(167, 169, 172, var(--tw-text-opacity));
  font-family: 'Fira Code', 'Fira Mono', Menlo, Consolas, 'DejaVu Sans Mono',
  						monospace;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  line-height: 1.5;
  -moz-tab-size: 2;
  -o-tab-size: 2;
  tab-size: 2;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
}
.dark code[class*='language-'], .dark pre[class*='language-'] {
  --tw-bg-opacity: 1;
  background-color: rgba(18, 21, 24, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(202, 203, 205, var(--tw-text-opacity));
}
code[class*='language-']::-moz-selection, code[class*='language-'] *::-moz-selection, pre[class*='language-'] *::-moz-selection {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  color: inherit;
}
.dark code[class*='language-']::-moz-selection, .dark code[class*='language-'] *::-moz-selection, .dark pre[class*='language-'] *::-moz-selection {
  --tw-bg-opacity: 1;
  background-color: rgba(167, 169, 172, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.25;
}
code[class*='language-']::selection, code[class*='language-'] *::selection, pre[class*='language-'] *::selection {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  color: inherit;
}
.dark code[class*='language-']::selection, .dark code[class*='language-'] *::selection, .dark pre[class*='language-'] *::selection {
  --tw-bg-opacity: 1;
  background-color: rgba(167, 169, 172, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.25;
}
pre[class*='language-'] {
  margin-bottom: 0.375rem;
  overflow: auto;
  padding: 1rem;
}
:not(pre) > code[class*='language-'] {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.375rem;
  padding-right: 0.375rem;
  white-space: normal;
}
@media print {
  code[class*='language-'], pre[class*='language-'] {
    text-shadow: none;
  }
}
.token.comment, .token.prolog, .token.cdata {
  --tw-text-opacity: 1;
  color: rgba(105, 108, 113, var(--tw-text-opacity));
}
.token.doctype, .token.punctuation, .token.entity {
  --tw-text-opacity: 1;
  color: rgba(202, 203, 205, var(--tw-text-opacity));
}
.token.attr-name, .token.class-name, .token.boolean, .token.constant, .token.number, .token.atrule {
  --tw-text-opacity: 1;
  color: rgba(245, 158, 11, var(--tw-text-opacity));
}
.token.keyword {
  --tw-text-opacity: 1;
  color: rgba(236, 72, 153, var(--tw-text-opacity));
}
.token.property, .token.tag, .token.symbol, .token.deleted, .token.important {
  --tw-text-opacity: 1;
  color: rgba(239, 68, 68, var(--tw-text-opacity));
}
.token.selector, .token.string, .token.char, .token.builtin, .token.inserted, .token.regex, .token.attr-value, .token.attr-value > .token.punctuation {
  --tw-text-opacity: 1;
  color: rgba(16, 185, 129, var(--tw-text-opacity));
}
.token.variable, .token.operator, .token.function {
  --tw-text-opacity: 1;
  color: rgba(59, 130, 246, var(--tw-text-opacity));
}
.token.url {
  color: hsl(187, 47%, 55%);
}
.token.attr-value > .token.punctuation.attr-equals, .token.special-attr > .token.attr-value > .token.value.css {
  color: hsl(220, 14%, 71%);
}
.language-css .token.selector {
  color: hsl(355, 65%, 65%);
}
.language-css .token.property {
  color: hsl(220, 14%, 71%);
}
.language-css .token.function, .language-css .token.url > .token.function {
  color: hsl(187, 47%, 55%);
}
.language-css .token.url > .token.string.url {
  color: hsl(95, 38%, 62%);
}
.language-css .token.important, .language-css .token.atrule .token.rule {
  color: hsl(286, 60%, 67%);
}
.language-javascript .token.operator {
  color: hsl(286, 60%, 67%);
}
.language-javascript
					.token.template-string
					> .token.interpolation
					> .token.interpolation-punctuation.punctuation {
  color: hsl(5, 48%, 51%);
}
.language-json .token.operator {
  color: hsl(220, 14%, 71%);
}
.language-json .token.null.keyword {
  color: hsl(29, 54%, 61%);
}
.language-markdown .token.url, .language-markdown .token.url > .token.operator, .language-markdown .token.url-reference.url > .token.string {
  color: hsl(220, 14%, 71%);
}
.language-markdown .token.url > .token.content {
  color: hsl(207, 82%, 66%);
}
.language-markdown .token.url > .token.url, .language-markdown .token.url-reference.url {
  color: hsl(187, 47%, 55%);
}
.language-markdown .token.blockquote.punctuation, .language-markdown .token.hr.punctuation {
  color: hsl(220, 10%, 40%);
  font-style: italic;
}
.language-markdown .token.code-snippet {
  color: hsl(95, 38%, 62%);
}
.language-markdown .token.bold .token.content {
  color: hsl(29, 54%, 61%);
}
.language-markdown .token.italic .token.content {
  color: hsl(286, 60%, 67%);
}
.language-markdown .token.strike .token.content, .language-markdown .token.strike .token.punctuation, .language-markdown .token.list.punctuation, .language-markdown .token.title.important > .token.punctuation {
  color: hsl(355, 65%, 65%);
}
.token.bold {
  font-weight: bold;
}
.token.comment, .token.italic {
  font-style: italic;
}
.token.entity {
  cursor: help;
}
.token.namespace {
  opacity: 0.8;
}
.token.token.tab:not(:empty):before, .token.token.cr:before, .token.token.lf:before, .token.token.space:before {
  color: hsla(220, 14%, 71%, 0.15);
  text-shadow: none;
}
div.code-toolbar > .toolbar.toolbar > .toolbar-item {
  margin-right: 0.4em;
}
div.code-toolbar > .toolbar.toolbar > .toolbar-item > button, div.code-toolbar > .toolbar.toolbar > .toolbar-item > a, div.code-toolbar > .toolbar.toolbar > .toolbar-item > span {
  background: hsl(220, 13%, 26%);
  color: hsl(220, 9%, 55%);
  padding: 0.1em 0.4em;
}
div.code-toolbar > .toolbar.toolbar > .toolbar-item > button:hover, div.code-toolbar > .toolbar.toolbar > .toolbar-item > button:focus, div.code-toolbar > .toolbar.toolbar > .toolbar-item > a:hover, div.code-toolbar > .toolbar.toolbar > .toolbar-item > a:focus, div.code-toolbar > .toolbar.toolbar > .toolbar-item > span:hover, div.code-toolbar > .toolbar.toolbar > .toolbar-item > span:focus {
  background: hsl(220, 13%, 28%);
  color: hsl(220, 14%, 71%);
}
.line-highlight.line-highlight {
  background: hsla(220, 100%, 80%, 0.04);
}
.line-highlight.line-highlight:before, .line-highlight.line-highlight[data-end]:after {
  background: hsl(220, 13%, 26%);
  color: hsl(220, 14%, 71%);
  padding: 0.1em 0.6em;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.2);
}
pre[id].linkable-line-numbers.linkable-line-numbers
					span.line-numbers-rows
					> span:hover:before {
  background-color: hsla(220, 100%, 80%, 0.04);
}
.line-numbers.line-numbers .line-numbers-rows, .command-line .command-line-prompt {
  border-right-color: hsla(220, 14%, 71%, 0.15);
}
.line-numbers .line-numbers-rows > span:before, .command-line .command-line-prompt > span:before {
  color: hsl(220, 14%, 45%);
}
.rainbow-braces .token.token.punctuation.brace-level-1, .rainbow-braces .token.token.punctuation.brace-level-5, .rainbow-braces .token.token.punctuation.brace-level-9 {
  color: hsl(355, 65%, 65%);
}
.rainbow-braces .token.token.punctuation.brace-level-2, .rainbow-braces .token.token.punctuation.brace-level-6, .rainbow-braces .token.token.punctuation.brace-level-10 {
  color: hsl(95, 38%, 62%);
}
.rainbow-braces .token.token.punctuation.brace-level-3, .rainbow-braces .token.token.punctuation.brace-level-7, .rainbow-braces .token.token.punctuation.brace-level-11 {
  color: hsl(207, 82%, 66%);
}
.rainbow-braces .token.token.punctuation.brace-level-4, .rainbow-braces .token.token.punctuation.brace-level-8, .rainbow-braces .token.token.punctuation.brace-level-12 {
  color: hsl(286, 60%, 67%);
}
pre.diff-highlight > code .token.token.deleted:not(.prefix), pre > code.diff-highlight .token.token.deleted:not(.prefix) {
  background-color: hsla(353, 100%, 66%, 0.15);
}
pre.diff-highlight > code .token.token.deleted:not(.prefix)::-moz-selection, pre.diff-highlight > code .token.token.deleted:not(.prefix) *::-moz-selection, pre > code.diff-highlight .token.token.deleted:not(.prefix)::-moz-selection, pre > code.diff-highlight .token.token.deleted:not(.prefix) *::-moz-selection {
  background-color: hsla(353, 95%, 66%, 0.25);
}
pre.diff-highlight > code .token.token.deleted:not(.prefix)::selection, pre.diff-highlight > code .token.token.deleted:not(.prefix) *::selection, pre > code.diff-highlight .token.token.deleted:not(.prefix)::selection, pre > code.diff-highlight .token.token.deleted:not(.prefix) *::selection {
  background-color: hsla(353, 95%, 66%, 0.25);
}
pre.diff-highlight > code .token.token.inserted:not(.prefix), pre > code.diff-highlight .token.token.inserted:not(.prefix) {
  background-color: hsla(137, 100%, 55%, 0.15);
}
pre.diff-highlight > code .token.token.inserted:not(.prefix)::-moz-selection, pre.diff-highlight > code .token.token.inserted:not(.prefix) *::-moz-selection, pre > code.diff-highlight .token.token.inserted:not(.prefix)::-moz-selection, pre > code.diff-highlight .token.token.inserted:not(.prefix) *::-moz-selection {
  background-color: hsla(135, 73%, 55%, 0.25);
}
pre.diff-highlight > code .token.token.inserted:not(.prefix)::selection, pre.diff-highlight > code .token.token.inserted:not(.prefix) *::selection, pre > code.diff-highlight .token.token.inserted:not(.prefix)::selection, pre > code.diff-highlight .token.token.inserted:not(.prefix) *::selection {
  background-color: hsla(135, 73%, 55%, 0.25);
}
.prism-previewer.prism-previewer:before, .prism-previewer-gradient.prism-previewer-gradient div {
  border-color: hsl(224, 13%, 17%);
}
.prism-previewer-color.prism-previewer-color:before, .prism-previewer-gradient.prism-previewer-gradient div, .prism-previewer-easing.prism-previewer-easing:before {
  border-radius: 0.3em;
}
.prism-previewer.prism-previewer:after {
  border-top-color: hsl(224, 13%, 17%);
}
.prism-previewer-flipped.prism-previewer-flipped.after {
  border-bottom-color: hsl(224, 13%, 17%);
}
.prism-previewer-angle.prism-previewer-angle:before, .prism-previewer-time.prism-previewer-time:before, .prism-previewer-easing.prism-previewer-easing {
  background: hsl(219, 13%, 22%);
}
.prism-previewer-angle.prism-previewer-angle circle, .prism-previewer-time.prism-previewer-time circle {
  stroke: hsl(220, 14%, 71%);
  stroke-opacity: 1;
}
.prism-previewer-easing.prism-previewer-easing circle, .prism-previewer-easing.prism-previewer-easing path, .prism-previewer-easing.prism-previewer-easing line {
  stroke: hsl(220, 14%, 71%);
}
.prism-previewer-easing.prism-previewer-easing circle {
  fill: transparent;
}
`}</style>
	);
}
